import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import CountryGuides from "./index";
import { Globe } from "lucide-react";

const countryGuideRoutes = [	
    generateCRUDRoutes({
        mainTitle: "Country Guide",
        basePath: "country-guide",
        mainComponent: <CountryGuides />,
        layout: "/console",
        icon: <Globe className="icon-item" />,
        subTitle:"Country Guide",
        level:4,
        moduleId: 0,
    })
];

export default countryGuideRoutes;